export function normalizePlate(value) {
  let normalized = value.toUpperCase().replace(/\s+/g, '');
  if (!normalized.includes('-')) {
    const match = normalized.match(/^([A-Z]+)([0-9]+)$/);
    if (match) {
      return `${match[1]}-${match[2]}`;
    }
  }
  return normalized;
}

export function getPlateFromPath(pathname) {
  const trimmedPath = pathname.replace(/^\/+|\/+$/g, '');

  if (!trimmedPath) {
    return '';
  }

  return normalizePlate(decodeURIComponent(trimmedPath));
}
